<template>
	<div id="interface-message" v-show="getMessages[0].message" v-on:click="hide()">
		<div class="message">
			{{ getMessages[0].message }}
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getInterfaceMessage',
      'getMessages'
    ])
  },
  methods: {
    hide () {
      this.$store.commit('addMessage', {})
    }
  }
}
</script>
